"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffectActionHandler = exports.ApplyEffectActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
const Duration_1 = require("../../Duration");
const Target_1 = require("../../Target");
class ApplyEffectActionArgs {
    constructor(effect, target = Target_1.Target.Self, duration = Duration_1.Duration.Permanent, supernatural = false) {
        this.effect = effect;
        this.target = target;
        this.duration = duration;
        this.supernatural = supernatural;
        this.__type = ActionType_1.ActionType.ApplyEffect;
        this.__typeName = "ApplyEffect";
    }
}
exports.ApplyEffectActionArgs = ApplyEffectActionArgs;
let ApplyEffectActionHandler = class ApplyEffectActionHandler {
    activate(sequence, container, action) {
        const { target, effect, duration, supernatural } = action.args;
        container.selectLivingTargets(action.actorId, target)
            .forEach(targetId => {
            if (effect.harmful) {
                container.applyDebuff({
                    sequence,
                    attackerId: action.actorId,
                    targetId,
                    duration,
                    supernatural,
                    effect
                });
            }
            else {
                container.applyBuff({
                    sequence,
                    creatorId: action.actorId,
                    targetId,
                    duration,
                    supernatural,
                    effect
                });
            }
        });
    }
};
ApplyEffectActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.ApplyEffect)
], ApplyEffectActionHandler);
exports.ApplyEffectActionHandler = ApplyEffectActionHandler;
